import { x } from '@xstyled/styled-components';
import React, { FC } from 'react';
import LockIcon from '~/assets/icons/lock.svg';
import { Capsule } from '~/ui/capsules';
import { Flex } from '~/ui/flex/Flex';
import { Chapter, Sequence, TrainingState, useTrainingStore } from '../state';
import { Chevron } from './Chevron';
import { ItemContainer } from './ItemContainer';
import { SequenceIcon } from './SequenceIcon';
import { t } from 'ttag';
import { select } from '~/lib/select';

const selector = (s: TrainingState) => select(s, 'highestUnlockedPosition', 'skip');

export const NavItem: FC<{
  expanded: boolean;
  item: Chapter | Sequence;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  activeItemPosition: any;
  onClick: () => void;
}> = ({ item, onClick, expanded, activeItemPosition }) => {
  let { highestUnlockedPosition } = useTrainingStore(selector);
  const { skip } = useTrainingStore(selector);
  const { title, position } = item;

  if (highestUnlockedPosition < 0 && activeItemPosition) {
    highestUnlockedPosition = activeItemPosition;
  }

  return (
    <ItemContainer ariaExpanded={expanded} item={item} onClick={onClick}>
      <Capsule highlighted={item.position <= highestUnlockedPosition}>
        {item.kind === 'chapter' ? (
          <x.small fontWeight="bold" fontSize="16px">
            {position / 10000}
          </x.small>
        ) : (
          <SequenceIcon icon={item.icon} />
        )}
      </Capsule>
      <Flex flexDirection="column">
        <x.small
          fontSize={{ _: 'md', sm: 'xs' }}
          className="itemStyleForDarkTheme"
          mt="5px"
        >
          {title}
        </x.small>
      </Flex>
      <x.div
        marginTop="6px"
        w={24}
        h={24}
        display="flex"
        justifyContent="flex-end"
      >
        {position <= highestUnlockedPosition ? (
          <Chevron expanded={expanded} />
        ) : !skip ? (
          <LockIcon role="img" aria-label={t`Finish previous chapter to unlock`} />
        ) : false}
      </x.div>
    </ItemContainer>
  );
};
